import React from 'react';
import moment from 'moment';
import { carrierFilter, shipperFilter } from 'components/design-system/presets';
import { FilterAutocompleteEditor } from 'components/design-system/molecules/FilterAutocompleteEditor';
import { FilterDateRange } from 'components/design-system/molecules/FilterDateRange';
import { getShipmentsByReferenceNumber } from 'utils/ShipmentWebAPIUtils';
const searchShipments = async (query) => {
    var _a;
    const reqQuery = {
        reference: [query.toLowerCase()],
        page: 1,
        per_page: 5,
        paginate: false,
        select: 'reference_numbers timeline status shipment_id',
        unconstrain: true,
    };
    try {
        const res = await getShipmentsByReferenceNumber(reqQuery);
        return (((_a = res === null || res === void 0 ? void 0 : res.entity) === null || _a === void 0 ? void 0 : _a.items) || []);
    }
    catch (_e) {
        return [];
    }
};
export function makeCarrierDashboardFilters({ isAdmin, }) {
    const defaultStart = moment().subtract(15, 'days').startOf('day').toDate();
    const defaultEnd = moment().endOf('day').toDate();
    const configs = [];
    configs.push({
        id: 'shipment',
        label: 'Shipment',
        kind: 'autocomplete-multi',
        initialValue: [],
        toApiParam: { name: 'shipment' },
        render: (ctx) => (React.createElement(FilterAutocompleteEditor, { onSearch: searchShipments, toItem: (s) => ({
                id: s._id,
                label: s.shipment_id || s._id,
                description: s.shipment_type,
            }), value: ctx.value || [], labels: ctx.labels, onAdd: ctx.onAdd, onRemove: ctx.onRemove, placeholder: "Search by reference..." })),
    });
    if (isAdmin) {
        configs.push(carrierFilter('carrier', 'Carrier'));
        configs.push(shipperFilter('shipper', 'Shipper'));
    }
    configs.push({
        id: 'date_range',
        label: 'Date Range',
        kind: 'date-range',
        initialValue: { from: defaultStart, to: defaultEnd },
        toApiParam: {
            name: 'date_range',
            transform: (v) => {
                const range = v;
                if (!(range === null || range === void 0 ? void 0 : range.from) || !(range === null || range === void 0 ? void 0 : range.to))
                    return undefined;
                return {
                    start_date: moment(range.from).startOf('day').format(),
                    end_date: moment(range.to).endOf('day').format(),
                    date_type: 'pickup',
                };
            },
        },
        render: (ctx) => {
            var _a;
            const range = ctx.value;
            const popoverValue = (range === null || range === void 0 ? void 0 : range.from)
                ? { from: range.from, to: (_a = range.to) !== null && _a !== void 0 ? _a : undefined }
                : undefined;
            return (React.createElement(FilterDateRange, { value: popoverValue, onChange: (next) => {
                    var _a;
                    if (!next) {
                        ctx.onChange(null);
                        return;
                    }
                    ctx.onChange({ from: next.from, to: (_a = next.to) !== null && _a !== void 0 ? _a : null });
                } }));
        },
    });
    return configs;
}
